var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgActDocumentIcon = function SvgActDocumentIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 26.5,
    height: 26.5,
    rx: 5.25,
    fill: "#F2FBF7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 26.5,
    height: 26.5,
    rx: 5.25,
    stroke: "#85DAB4",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4163 12.8294V10.6222C18.4163 10.2534 18.2695 9.89918 18.0086 9.63824L16.0407 7.67038C15.7797 7.40944 15.4256 7.26261 15.0568 7.26261H10.0661C9.29722 7.26261 8.67444 7.8854 8.67444 8.65431V18.3962C8.67444 19.1651 9.29722 19.7879 10.0661 19.7879H12.8495",
    stroke: "#52CB94",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7623 11.4376H16.3291",
    stroke: "#52CB94",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7623 13.5253H16.3291",
    stroke: "#52CB94",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7623 15.6129H12.154",
    stroke: "#52CB94",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7955 20.3215L14.6953 19.5665C14.6953 19.5665 14.6953 19.5665 14.6953 19.5658L14.2325 18.9604C13.9778 18.6271 13.9778 18.1644 14.2325 17.8311L14.6953 17.2257C14.6953 17.2257 14.6953 17.2257 14.6953 17.225L14.7962 16.4693C14.8518 16.0532 15.1789 15.7261 15.595 15.6705L16.35 15.5703C16.35 15.5703 16.35 15.5703 16.3507 15.5703L16.9561 15.1075C17.2894 14.8528 17.7521 14.8528 18.0854 15.1075L18.6908 15.5703C18.6908 15.5703 18.6908 15.5703 18.6915 15.5703L19.4472 15.6712C19.8633 15.7268 20.1904 16.0539 20.246 16.47L20.3462 17.225C20.3462 17.225 20.3462 17.225 20.3462 17.2257L20.809 17.8311C21.0637 18.1644 21.0637 18.6271 20.809 18.9604L20.3462 19.5658C20.3462 19.5658 20.3462 19.5658 20.3462 19.5665L20.2453 20.3222C20.1897 20.7383 19.8626 21.0654 19.4465 21.121L18.6915 21.2212C18.6915 21.2212 18.6915 21.2212 18.6908 21.2212L18.0854 21.684C17.7521 21.9387 17.2894 21.9387 16.9561 21.684L16.3507 21.2212C16.3507 21.2212 16.3507 21.2212 16.35 21.2212L15.5943 21.1203C15.1782 21.0654 14.8511 20.7376 14.7955 20.3215V20.3215Z",
    stroke: "#52CB94",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6037 17.8549L17.2503 19.2083L16.4389 18.3962",
    stroke: "#52CB94",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgActDocumentIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "act-document-icon.37d99e32047c70c96af19a2723f423fe.svg";